<template>
  <header role="banner" class="header">
    <CompanyHeader
      v-if="!isEmbedded"
      :companyLogo="companyLogo"
      :companyName="company.name"
      :companyUrl="company.websiteUrl"
      ref="company-header" />
  </header>
</template>

<script>
import { mapState } from 'vuex';

import CompanyHeader from '@/components/CompanyHeader.vue';

const DEFAULT_COMPANY_LOGO = '/img/default-logo.svg';

export default {
  components: {
    CompanyHeader,
  },
  computed: {
    ...mapState('Company', {
      company: state => state.company,
    }),
    companyLogo() {
      return (this.company && this.company.logo)
        ? this.company.logo
        : DEFAULT_COMPANY_LOGO;
    },
    isEmbedded() {
      if (!this.$route || !this.$route.query) {
        return false;
      }
      return this.$route.query.embed === 'true';
    },
  },
};
</script>
